import { declareIndices } from "@thi.ng/vectors";
import { AColor } from "./internal/acolor";
import { ensureArgs } from "./internal/ensure-args";
export function hsva(...args) {
    return new HSVA(...ensureArgs(args));
}
export class HSVA extends AColor {
    get mode() {
        return "hsv";
    }
    copy() {
        return new HSVA(this.deref());
    }
    copyView() {
        return new HSVA(this.buf, this.offset, this.stride);
    }
    empty() {
        return new HSVA();
    }
}
declareIndices(HSVA.prototype, ["h", "s", "v", "a"]);
